export default {"src":"/_next/static/media/Cerebral Palsy.1f558035.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};